
















































import {Component} from 'vue-property-decorator'
import {TabBase} from "@/views/Vozila/DetaljiVozila/TabBase";
import {TroskoviVozila} from "@/services/BackendProxies";
import {formatDate, formatPrice} from "@/utils/formatters";
import dataProxy from '@/services/data-proxy.service'
import * as _ from 'lodash'

@Component({})
export default class Tab3 extends TabBase {
    troskoviVozila: TroskoviVozila = TroskoviVozila.fromJS({troskoviOdrzavanja: []});
    columns1 = [];
    columns2 = [];
    options1 = {pagination: true, search: true};
    options2 = {pagination: true};
    chartOptions = {
        xaxis: {
            mode: 'time',
            show: true,
            timeformat: '%Y',
        }
    };

    get ukupniTroskoviOdrzavanja() {
        return _.sumBy(this.troskoviVozila.troskoviOdrzavanja, 'iznos');
    }

    get ukupnaAmortizacija() {
        return _.sumBy(this.troskoviVozila.amortizacija, 'iznosAmortizacije');
    }

    get ukupnoTroskovi() {
        return this.ukupniTroskoviOdrzavanja + this.ukupnaAmortizacija;
    }

    get chartData() {
        let cum = 0;
        /*const ukupniTroskovi = [];
        for(let x of this.troskoviVozila.troskoviOdrzavanja) {
            ukupniTroskovi.push({datum: x.datum, iznos: x.iznos});
        }
        for(let x of this.troskoviVozila.amortizacija) {
            ukupniTroskovi.push({datum: new Date(x.godina, x.mesec, 1), iznos: x.iznosAmortizacije});
        }*/
        return [{
            color: '#78c350',
            data: this.troskoviVozila.troskoviOdrzavanja.sort((a, b) => a.datum > b.datum ? 1 : -1).map(x => {
                cum = cum + x.iznos;
                return [x.datum.getTime() / 1000, cum];
            })
        },
        ];
    }

    async created() {
        this.columns1 = [
            {field: 'datum', title: this.$i18n.t('datum'), width: 80, formatter: formatDate},
            {field: 'tipDokumenta', title: this.$i18n.t('tipDokumenta'), width: 160},
            {field: 'broj', title: this.$i18n.t('brojDokumenta'), width: 140},
            {field: 'dobavljac', title: this.$i18n.t('dobavljac')},
            {field: 'iznos', title: this.$i18n.t('iznos'), formatter: formatPrice, align: 'right', width: 120},
        ];
        this.columns2 = [
            {field: 'godina', title: this.$i18n.t('godina'), width: 80},
            {field: 'mesec', title: this.$i18n.t('mesec'), width: 80},
            {
                field: 'iznosAmortizacije',
                title: this.$i18n.t('iznosAmortizacije'),
                width: 120,
                formatter: formatPrice,
                align: 'right'
            },
            {
                field: 'preostaliIznos',
                title: this.$i18n.t('preostaliIznos'),
                width: 120,
                formatter: formatPrice,
                align: 'right'
            },
        ];

        this.troskoviVozila = await this.loadData(() => dataProxy.vratiTroskoveIzabranogVozila(this.vozilo.id))();
    }
}
